import { UseQueryOptions, useQuery, useQueryClient } from 'react-query';
import { useAuth } from 'react-oidc-context';
import axios from 'axios';

import { ProblemDetails } from '../../autogenerated/data-contracts';
import useDepositNowStore from 'core/stores/deposit-now-store';

function useRefreshToken(options?: Omit<UseQueryOptions, 'queryFn'>) {
    const queryClient = useQueryClient();
    const auth = useAuth();
    const { depositUniqueReference, spectreControlUrl, vaultToken } =
        useDepositNowStore();

    return useQuery(
        [
            'refresh-token',
            { token: auth.user?.access_token, tokenType: auth.user?.token_type }
        ],
        async () => {
            const baseURL = spectreControlUrl;

            const axiosInstance = axios.create({
                baseURL,
                headers: {
                    Authorization: `Bearer ${vaultToken}`,
                    'Cache-FormControl': 'no-cache, no-store, must-revalidate',
                    Expires: '0',
                    Pragma: 'no-cache'
                },
                withCredentials: true
            });

            return axiosInstance
                .post<void | ProblemDetails>(
                    `/api/auth/refresh`,
                    { depositId: depositUniqueReference }
                    // {
                    //     withCredentials: true
                    // }
                )
                .then((response) => response.data);

            // const token = (await refreshVaultToken()).data!.token || null;
            // if (token) {
            //     // as the token needs to be refreshed in so many places, better to store it in a global store
            //     setVaultToken(token);
            // }
            // return token;
        },
        {
            enabled: false,
            onError: () => {
                queryClient.invalidateQueries('use-request-token');
            }
        }
    );
}

export default useRefreshToken;

export const refreshToken = async (): Promise<string | null> => {
    const store = useDepositNowStore.getState(); // Access store without hooks
    const {
        depositUniqueReference,
        setVaultToken,
        spectreControlUrl,
        vaultToken
    } = store;

    try {
        const axiosInstance = axios.create({
            baseURL: spectreControlUrl,
            headers: {
                Authorization: `Bearer ${vaultToken}`,
                'Cache-Control': 'no-cache, no-store, must-revalidate',
                Expires: '0',
                Pragma: 'no-cache'
            },
            withCredentials: true
        });

        const response = await axiosInstance
            .post<{ token: string }>(`/api/auth/refresh`, {
                depositId: depositUniqueReference
            })
            .catch((error) => {
                if (error.response.status === 401) {
                    // Handle unauthorized error
                    console.error('Unauthorized access:', error);
                    // Optionally, you can redirect to login or show a message
                }
            });

        const newToken = response?.data.token || null;

        if (newToken) {
            // Update the token in the global store
            setVaultToken(newToken);
        }

        return newToken;
    } catch (error) {
        console.error('Failed to refresh token:', error);
        return null;
    }
};
